var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d84315"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.25 15.75c-.1117 0-.2158-.0433-.295-.1217-.1625-.1625-.1625-.4266 0-.5891l2.6217-2.6217h-8.9934c-.23 0-.4166-.1867-.4166-.4167s.1866-.4166.4166-.4166h8.9942l-2.6217-2.6217c-.1625-.1625-.1625-.42667 0-.58917.0784-.08.1834-.12333.2942-.12333s.2158.04333.295.12167l3.3333 3.33333c.0384.0383.0692.0842.0909.1358.0416.1009.0416.2175 0 .3184-.0209.0508-.0517.0966-.0909.135l-3.3325 3.3333c-.08.0792-.1841.1225-.2958.1225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.50167 22c-.06084 0-.12167-.0067-.18084-.02l-6.6675-1.4808c-.38416-.085-.6525-.4192-.65333-.8125v-15.3717c0-.39417.26917-.72833.65333-.81333l6.66667-1.48167c.05917-.01333.12-.02.18-.02.45917 0 .8333.37333.8333.83333v.83334h5.8334c.46 0 .8333.37416.8333.83333v2.08333c0 .23-.1867.41667-.4167.41667s-.4166-.18667-.4166-.41667v-2.08333h-5.8334v15h5.8334v-2.0833c0-.23.1866-.4167.4166-.4167s.4167.1867.4167.4167v2.0833c0 .46-.3733.8333-.8333.8333h-5.8334v.8334c0 .06-.0066.12-.02.1791-.0483.2175-.1783.4034-.3658.5234-.13333.0858-.2875.1308-.44583.1308zm-6.6675-17.685v15.3708l6.66666 1.4809v-18.33337z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 13.6667c-.91917 0-1.66667-.7475-1.66667-1.6667s.7475-1.6667 1.66667-1.6667 1.66667.7475 1.66667 1.6667-.7475 1.6667-1.66667 1.6667zm0-2.5c-.45917 0-.83333.3741-.83333.8333 0 .46.37416.8333.83333.8333s.83333-.3733.83333-.8333c0-.4592-.37333-.8333-.83333-.8333z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.6f1c4ecc83e30786bb82d435e8e6de5f.svg";
export { ForwardRef as ReactComponent };